// extracted by mini-css-extract-plugin
export default {"box":"rNa_lbcJQlDZlD5JuLJJ"};